import { render } from "./DashboardScreen1.vue?vue&type=template&id=3ee56104&scoped=true"
import script from "./DashboardScreen1.vue?vue&type=script&lang=js"
export * from "./DashboardScreen1.vue?vue&type=script&lang=js"

import "./DashboardScreen1.vue?vue&type=style&index=0&id=3ee56104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee56104"]])

export default __exports__